import React, { useContext, useEffect, useRef, useState } from "react";
import { VendorContext } from "../../../../../context/vendor/VendorContext";
import { Button, Container, Column, ColumnButtons, Tittle } from "../style";
import { CssTextField, ButtonUpload } from "../../style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import stylesCss, {
  BoxDialog,
  ContentDialog,
  ButtonCancel,
  OneColumn,
  BorderContainer,
} from "./style";
import {
  Dialog,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import Wait from "../../../../Wait";

const typeResponse = [
  { id: 0, name: "no" },
  { id: 1, name: "yes" },
];

const Step4 = () => {
  const { t } = useTranslation();
  const [isLoading, setLoading] = useState(true);
  const {
    steps,
    activeStep,
    vendorInformation,
    vendDocumentation,
    vendGeneralInformation,
    vendFlowEnrollment,
    setActiveStep,
    getBase64,
    getVendGeneralInformation,
    getCompanyInformation,
    sendVendGeneralInformation,
    sendVendFlowEnrollment,
    sendVendDocumentation,
  } = useContext(VendorContext);

  const classesSx = stylesCss;
  const [messageError, setMessageError] = useState("");
  const [showDialogError, setShowDialogError] = useState(false);
  const uploadImpRenta = useRef(null);
  const uploadInfResponSocial = useRef(null);
  const uploadMisionVision = useRef(null);
  const uploadDeclaIVA = useRef(null);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleUpload = (e, tag) => {
    e.preventDefault();
    if (tag === 1) {
      uploadImpRenta.current.click();
    } else if (tag === 2) {
      uploadInfResponSocial.current.click();
    } else if (tag === 3) {
      uploadMisionVision.current.click();
    } else if (tag === 4) {
      uploadDeclaIVA.current.click();
    }
  };
  const handleFileUpload = (event) => {
    console.log(event);
    const fileUploaded = event.target.files[0];
    getBase64(fileUploaded)
      .then((data) => {
        vendDocumentation[event.target.name] = data;
        sendVendDocumentation(vendDocumentation);
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };
  const handleInformation = (event) => {
    event.preventDefault();
    vendGeneralInformation[event.target.name] = event.target.value;
    console.log(vendGeneralInformation);
    sendVendGeneralInformation(vendGeneralInformation);
  };
  const handleInformationWithDescription = (event, description) => {
    event.preventDefault();
    if (event.target.value === "0") {
      vendGeneralInformation[description] = "";
    }
    handleInformation(event);
  };

  const submitForm = async (e) => {
    e.preventDefault();
    console.log(vendDocumentation);
    console.log(vendorInformation);
    if (vendorInformation.country === "ECU") {
      if (vendDocumentation.declaracioN_IMP_RENTA === "") {
        // alert("Error: missing " + ta);
        setMessageError("alertMissingAttach");
        setShowDialogError(true);
      } else if (vendorInformation.type === "2") {
        if (
          vendDocumentation.informE_RESPONSABILIDAD_SOCIAL === "" ||
          vendDocumentation.visioN_MISION_VALORES === ""
        ) {
          setMessageError("alertMissingAttach");
          setShowDialogError(true);
        }
      } else if (
        vendorInformation.type === "1" &&
        vendDocumentation.declaracioN_IVA === ""
      ) {
        setMessageError("alertMissingAttach");
        setShowDialogError(true);
      } else {
        if (vendFlowEnrollment.lasT_STEP === activeStep) {
          vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
          await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
        }
        handleNext();
      }
    } else {
      if (vendFlowEnrollment.lasT_STEP === activeStep) {
        vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
        await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
      }
      handleNext();
    }
  };
  const handleCloseDialog = (e, reason) => {
    setShowDialogError(false);
  };
  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendGeneralInformation()]);
      await Promise.all([getCompanyInformation()]);
      setLoading(false);
    };
    fetchData2();
  }, []);

  if (isLoading) {
    return <Wait />;
  }
  return (
    <>
      {showDialogError && (
        <Dialog
          open={showDialogError}
          onClose={(e, reason) => handleCloseDialog(e, reason)}
        >
          <DialogTitle>{t("incompleteInfo")}</DialogTitle>
          <ContentDialog>
            <BoxDialog>{t(messageError)}</BoxDialog>
          </ContentDialog>
          <ButtonCancel onClick={handleCloseDialog}>{t("close")}</ButtonCancel>
        </Dialog>
      )}
      <form
        onSubmit={(e) => {
          submitForm(e);
        }}
      >
        <Tittle>{t(steps[3])}</Tittle>
        {vendorInformation.type === "2" && (
          <>
            <BorderContainer>
              <OneColumn>
                <h5>{t("fliQuestion1_1")}</h5>
                <RadioGroup
                  id="fliquestioN1_1_RESP"
                  name="fliquestioN1_1_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(
                      e,
                      "fliquestioN1_1_DESCRIPTION"
                    )
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.fliquestioN1_1_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={
                              !vendGeneralInformation.fliquestioN1_1_RESP
                            }
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.fliquestioN1_1_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.fliquestioN1_1_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="fliquestioN1_1_DESCRIPTION"
                      name="fliquestioN1_1_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>
          </>
        )}
        {vendorInformation.type === "1" && (
          <>
            <BorderContainer>
              <OneColumn>
                <h5>{t("fliQuestion1")}</h5>
                <RadioGroup
                  id="fliquestioN1_RESP"
                  name="fliquestioN1_RESP"
                  onChange={(e) =>
                    handleInformationWithDescription(
                      e,
                      "fliquestioN1_DESCRIPTION"
                    )
                  }
                  sx={classesSx.radioGroup}
                  value={vendGeneralInformation.fliquestioN1_RESP}
                >
                  {typeResponse.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item.id}
                        control={
                          <Radio
                            required={!vendGeneralInformation.fliquestioN1_RESP}
                            sx={classesSx.radio}
                          />
                        }
                        label={t(item.name)}
                      />
                    );
                  })}
                </RadioGroup>
                {vendGeneralInformation.fliquestioN1_RESP === "1" && (
                  <>
                    <br />
                    <CssTextField
                      value={vendGeneralInformation.fliquestioN1_DESCRIPTION}
                      multiline
                      type={"text"}
                      required
                      fullWidth
                      label={t("describeBelow")}
                      id="fliquestioN1_DESCRIPTION"
                      name="fliquestioN1_DESCRIPTION"
                      onChange={(e) => handleInformation(e)}
                    />
                  </>
                )}
              </OneColumn>
            </BorderContainer>
          </>
        )}
        <BorderContainer>
          <OneColumn>
            <h5>{t("fliQuestion2")}</h5>
            <RadioGroup
              id="fliquestioN2_RESP"
              name="fliquestioN2_RESP"
              onChange={(e) =>
                handleInformationWithDescription(e, "fliquestioN2_DESCRIPTION")
              }
              sx={classesSx.radioGroup}
              value={vendGeneralInformation.fliquestioN2_RESP}
            >
              {typeResponse.map((item, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.id}
                    control={
                      <Radio
                        required={!vendGeneralInformation.fliquestioN2_RESP}
                        sx={classesSx.radio}
                      />
                    }
                    label={t(item.name)}
                  />
                );
              })}
            </RadioGroup>
            {vendGeneralInformation.fliquestioN2_RESP === "1" && (
              <>
                <br />
                <CssTextField
                  value={vendGeneralInformation.fliquestioN2_DESCRIPTION}
                  multiline
                  type={"text"}
                  required
                  fullWidth
                  label={t("describeBelow")}
                  id="fliquestioN2_DESCRIPTION"
                  name="fliquestioN2_DESCRIPTION"
                  onChange={(e) => handleInformation(e)}
                />
              </>
            )}
          </OneColumn>
        </BorderContainer>
        <BorderContainer>
          <OneColumn>
            <h5>{t("fliQuestion3")}</h5>
            <RadioGroup
              id="fliquestioN3_RESP"
              name="fliquestioN3_RESP"
              onChange={(e) =>
                handleInformationWithDescription(e, "fliquestioN3_DESCRIPTION")
              }
              sx={classesSx.radioGroup}
              value={vendGeneralInformation.fliquestioN3_RESP}
            >
              {typeResponse.map((item, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.id}
                    control={
                      <Radio
                        required={!vendGeneralInformation.fliquestioN3_RESP}
                        sx={classesSx.radio}
                      />
                    }
                    label={t(item.name)}
                  />
                );
              })}
            </RadioGroup>
            {vendGeneralInformation.fliquestioN3_RESP === "1" && (
              <>
                <br />
                <CssTextField
                  value={vendGeneralInformation.fliquestioN3_DESCRIPTION}
                  multiline
                  type={"text"}
                  required
                  fullWidth
                  label={t("describeBelow")}
                  id="fliquestioN3_DESCRIPTION"
                  name="fliquestioN3_DESCRIPTION"
                  onChange={(e) => handleInformation(e)}
                />
              </>
            )}
          </OneColumn>
        </BorderContainer>
        <BorderContainer>
          <OneColumn>
            <h5>{t("fliQuestion4")}</h5>
            <RadioGroup
              id="fliquestioN4_RESP"
              name="fliquestioN4_RESP"
              onChange={(e) =>
                handleInformationWithDescription(e, "fliquestioN4_DESCRIPTION")
              }
              sx={classesSx.radioGroup}
              value={vendGeneralInformation.fliquestioN4_RESP}
            >
              {typeResponse.map((item, index) => {
                return (
                  <FormControlLabel
                    key={index}
                    value={item.id}
                    control={
                      <Radio
                        required={!vendGeneralInformation.fliquestioN4_RESP}
                        sx={classesSx.radio}
                      />
                    }
                    label={t(item.name)}
                  />
                );
              })}
            </RadioGroup>
            {vendGeneralInformation.fliquestioN4_RESP === "1" && (
              <>
                <br />
                <CssTextField
                  value={vendGeneralInformation.fliquestioN4_DESCRIPTION}
                  multiline
                  type={"text"}
                  required
                  fullWidth
                  label={t("describeBelow")}
                  id="fliquestioN4_DESCRIPTION"
                  name="fliquestioN4_DESCRIPTION"
                  onChange={(e) => handleInformation(e)}
                />
              </>
            )}
          </OneColumn>
        </BorderContainer>
        {vendorInformation.country === "ECU" && (
          <>
            <Tittle>{t("documentation")}</Tittle>
            <Container>
              <Column>
                <ButtonUpload onClick={(e) => handleUpload(e, 1)}>
                  {t("declarationVatLastYear")}
                  <UploadFileIcon />
                </ButtonUpload>
                <input
                  type="file"
                  accept="application/pdf"
                  name={"declaracioN_IMP_RENTA"}
                  ref={uploadImpRenta}
                  onChange={(e) => handleFileUpload(e)}
                  style={{ display: "none" }}
                />
              </Column>
              {vendorInformation.type === "2" && (
                <>
                  <Column>
                    <ButtonUpload onClick={(e) => handleUpload(e, 2)}>
                      {t("attachSocialReport")}
                      <UploadFileIcon />
                    </ButtonUpload>
                    <input
                      type="file"
                      accept="application/pdf"
                      name={"informE_RESPONSABILIDAD_SOCIAL"}
                      ref={uploadInfResponSocial}
                      onChange={(e) => handleFileUpload(e)}
                      style={{ display: "none" }}
                    />
                  </Column>
                  <Column>
                    <ButtonUpload onClick={(e) => handleUpload(e, 3)}>
                      {t("attachMissionVision")}
                      <UploadFileIcon />
                    </ButtonUpload>
                    <input
                      type="file"
                      accept="application/pdf"
                      name={"visioN_MISION_VALORES"}
                      ref={uploadMisionVision}
                      onChange={(e) => handleFileUpload(e)}
                      style={{ display: "none" }}
                    />
                  </Column>
                </>
              )}
              {vendorInformation.type === "1" && (
                <>
                  <Column>
                    <ButtonUpload onClick={(e) => handleUpload(e, 4)}>
                      {t("attachIvaReturn")}
                      <UploadFileIcon />
                    </ButtonUpload>
                    <input
                      type="file"
                      accept="application/pdf"
                      name={"declaracioN_IVA"}
                      ref={uploadDeclaIVA}
                      onChange={(e) => handleFileUpload(e)}
                      style={{ display: "none" }}
                    />
                  </Column>
                </>
              )}
            </Container>
          </>
        )}
        <Container>
          <ColumnButtons>
            <Button onClick={handleBack}>{t("back")}</Button>
          </ColumnButtons>
          <ColumnButtons>
            <Button>{t("next")}</Button>
          </ColumnButtons>
        </Container>
      </form>
    </>
  );
};

export default Step4;
